var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-dialogContainer"},[_c('div',[_c('BaseBusiness',{ref:"base",attrs:{"formParams":_vm.formParamsBase,"reMountPage":_vm.reMount}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }